import { render, staticRenderFns } from "./AssessmentTableInactive.vue?vue&type=template&id=628da230&scoped=true"
import script from "./AssessmentTableInactive.vue?vue&type=script&lang=js"
export * from "./AssessmentTableInactive.vue?vue&type=script&lang=js"
import style0 from "./AssessmentTableInactive.vue?vue&type=style&index=0&id=628da230&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628da230",
  null
  
)

export default component.exports